import type { Dispatch } from 'react'
import { createContext } from 'react'

export type Updates = Record<string, number[]>

export type UpdateReducerAction =
  | { action: 'set' | 'toggle'; device: string; updates: number[] }
  | { action: 'unset'; device: string }
  | { action: 'keep'; devices: string[] }

export const updateReducer = (
  state: Updates,
  action: UpdateReducerAction,
): Updates => {
  switch (action.action) {
    case 'set':
      return { ...state, [action.device]: action.updates }

    case 'toggle': {
      const nextState = { ...state }
      if (nextState[action.device] === undefined) {
        nextState[action.device] = action.updates
      } else {
        delete nextState[action.device]
      }
      return nextState
    }

    case 'unset': {
      const newState = { ...state }
      delete newState[action.device]
      return newState
    }

    case 'keep':
      return Object.keys(state)
        .filter((device) => action.devices.includes(device))
        .reduce<Updates>((acc, key) => {
          acc[key] = state[key]
          return acc
        }, {})

    default:
      throw new Error('Unknown action')
  }
}
export const UpdatesContext = createContext<{
  state: Updates
  dispatch: Dispatch<UpdateReducerAction>
}>({
  state: {},
  dispatch: () => {},
})
